import useSWR from "swr";

import SWR_KEYS from "@/constants/swr-keys";
import ISubject from "@/interfaces/subject.interface";
import subjectService from "@/services/subject.service";
import { PaginatedResponse, RequestPagination, RequestsBaseReturn } from "@/types/requests.types";

export type Props = RequestPagination;

type GetAllSwrParams = [string, number, number];

export type Return = RequestsBaseReturn<PaginatedResponse<ISubject> | null>;

const useGetSubjects = ({ pageNumber, pageSize }: Props): Return => {
  const fetcher = useSWR<PaginatedResponse<ISubject>, Error, GetAllSwrParams>(
    [SWR_KEYS.getSubjects, pageNumber, pageSize],
    ([, _pageNumber, _pageSize]) =>
      subjectService.getAll({ pageNumber: _pageNumber, pageSize: _pageSize }),
    { revalidateOnFocus: false, shouldRetryOnError: false, errorRetryCount: 0 }
  );

  const { data = null, isValidating: isLoading, error } = fetcher;

  return { data, isLoading, error };
};

export default useGetSubjects;
